export default function BrewbaseIcon({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) {
  return (
    <svg
      className={className}
      version="1.1"
      viewBox="0 0 23.425 27.525"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Brewbase Logo</title>
      <path
        d="m8.4029 0.40542c-0.22965 0.12536-0.3763 0.3623-0.38554 0.62377l0.0101 8.0114-1e-3 4.4188c-9.4e-4 0.22806 0.15493 0.41125 0.38117 0.41245 1.2555 7e-3 1.9282 0.0103 2.2172 5e-3 0.4559 6e-3 1.1645-0.83617 1.1583-1.3542 8e-3 -2.4908 0.0477-4.9481 0.03-7.395-0.16121-1.9645-1.4288-3.312-2.6767-4.7091-0.24665-0.21915-0.61875-0.0758-0.73357-0.0131z"
        fill={color ?? "currentColor"}
      />
      <path
        d="m15.844 0.13984c-1.2479 1.3971-2.2185 2.7324-2.3797 4.6969 0 0 0.12866 5.6952 0.15606 7.7799-0.10305 0.87922-0.53363 1.3868-0.98185 2.0169-0.34685 0.47402-0.87861 0.82063-1.4914 0.82063h-2.8556c-0.62433 0-0.93621 0.40472-1.2252 0.8325l-6.9717 10.417c-0.23123 0.33528-0.012 0.82114 0.39274 0.82114h3.0639c0.53184 0 0.97135-0.19668 1.2604-0.61289l7.2492-10.914c0.2065-0.30487 0.56122-0.47455 0.92811-0.44338 0.3669 0.0312 0.68866 0.2579 0.84077 0.59324l0.43718 0.95653 2.8593 6.2513 0.68161 1.4459 0.94568 2.0939c0.28904 0.41621 0.7456 0.62993 1.2774 0.62993h2.9161c0.35096 0 0.60576-0.271 0.41031-0.72398-0.51264-1.0381-1.2447-2.5535-1.4805-3.0417l-3.6571-7.9365-1.2004-2.6055c-0.0552-0.1609-0.0648-0.21903-0.0641-0.39998-1e-3 -0.9888-3e-3 -4.055-3e-3 -4.055l0.01-8.0114c-9e-3 -0.26147-0.15586-0.49838-0.38551-0.62374-0.0306-0.0167-0.39998-0.28592-0.73251 0.0124z"
        fill={color ?? "currentColor"}
      />
    </svg>
  );
}
